/**
 * getOr unpackes a value of type T that might be null or undefined (optional). If not
 * defined the orValue is returned
 * @param opt Value of type T, null or undefined
 * @param value value of type T that is returned if opt is not defined.
 * @returns opt if set, otherwise orValue value. Both values must be of type T.
 */
export const getOr = <T>(opt: T | null | undefined, orValue: T): T => (opt ? (opt as T) : orValue);
